import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import StockReturnService from "../services/stockReturnService";

export default function ViewStockReturnDetails() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) fetchDetails();
  }, [id]);

  // const fetchDetails = async () => {
  //   try {
  //     const res = await StockReturnService.getById(id);
  //     // const payload = res?.data?.data ?? res?.data ?? {};
  //     const payload = res?.data ?? {};
  //     setRows(
  //       payload.details ||
  //       payload.stockReturnDetails ||
  //       payload.data ||
  //       []
  //     );
  //   } catch {
  //     setRows([]);
  //   }
  // };

  const fetchDetails = async () => {
    try {
      const res = await StockReturnService.getById(id);
      console.log("API RESPONSE:", res);
      const payload = res?.data?.data || res?.data || res || {};
      setRows(payload.details || payload.stockReturnDetails || []);
    } catch (err) {
      console.error("Error:", err);
      setRows([]);
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="StockReturnDetails" secondTitle="Inventory" />

      <button className="btn btn-secondary m-2" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="card p-3 bg-white shadow-sm">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Voucher No</th>
              <th>To Store</th>
              <th>Item</th>
              <th>UOM</th>
              <th>Quantity</th>
              <th>Damaged Qty</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? rows.map((r, i) => (
              <tr key={i}>
                <td>{r.stockOutVoucherNo || "-"}</td>
                <td>{r.toStoreName || "-"}</td>
                <td>{r.itemName || r.itemId}</td>
                <td>{r.UOM}</td>
                <td>{Number(r.quantity || 0).toFixed(3)}</td>
                <td>{Number(r.damagedQty || 0).toFixed(3)}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="6" className="text-center">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
